import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TripAttributes } from '@albatrosdeveloper/ave-models-package';

export interface ModalCreatedTripsData {
  allCreatedTrips: TripAttributes[];
  currentSubRouteMongoId: string;
  currentSubRouteName: string;
}

@Component({
  selector: 'app-modal-created-trips',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './modal-created-trips.component.html',
  styles: [`
    .trips-table {
      width: 100%;
      max-height: 350px;
      overflow: auto;
    }
    .highlight-row {
      background-color: #f0fdf4 !important;
      font-weight: 500;
    }
  `]
})
export class ModalCreatedTripsComponent implements OnInit {
  displayedColumns: string[] = ['id', 'description', 'subRoute', 'dateRange', 'actions'];
  dataSource: TripAttributes[] = [];
  subRouteMongoId: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalCreatedTripsComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: ModalCreatedTripsData
  ) {}

  ngOnInit(): void {
    this.dataSource = this.data.allCreatedTrips || [];
    this.subRouteMongoId = this.data.currentSubRouteMongoId;
  }

  isCurrentSubRoute(element: TripAttributes): boolean {
    if (!element.subRoute) return false;
    return String(element.subRoute._id) === String(this.subRouteMongoId);
  }

  navigateToTrip(trip: TripAttributes): void {
    const urlTree = this.router.createUrlTree(['master', 'sales', 'trip'], {
      queryParams: { tripId: trip.id }
    });
    const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
    window.open(absoluteUrl, '_blank');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
